import { computed, getCurrentInstance } from "@vue/composition-api";
import { SystemSettings } from "@scrile/api-provider/dist/api/SystemSettingsProvider";
import { ACTION_TYPES } from "@/store/const";
import { StateRoot } from "@/store/state";
import { FrontendConfig } from "@/types";

export default function useSystemSettings() {
  const vm = getCurrentInstance();
  const systemSettings = computed<StateRoot["systemSettings"]>(() => vm?.$store.state.systemSettings ?? null);
  const frontendConfig = computed<FrontendConfig>(() =>
    typeof systemSettings.value?.frontendConfig === "string" ? JSON.parse(systemSettings.value.frontendConfig) : {}
  );
  const publicPaymentSystems = computed<StateRoot["publicPaymentSystems"]>(
    () => vm?.$store.state.publicPaymentSystems ?? null
  );
  const hasActivePaymentSystem = computed(() => publicPaymentSystems.value.length > 0);
  const creditCardAllowed = computed<StateRoot["creditCardAllowed"]>(() => vm?.$store.state.creditCardAllowed ?? true);
  const getData = () => vm?.$store.dispatch(ACTION_TYPES.GET_SYSTEM_SETTINGS) as Promise<SystemSettings>;

  return {
    systemSettings,
    publicPaymentSystems,
    creditCardAllowed,
    frontendConfig,
    hasActivePaymentSystem,
    getData,
  };
}
